import {
  coreExtensionData,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { EntityPageWithAnalytics } from './components';
import { CustomEntityProvider } from './hooks';

const customCatalogPageExtension = catalogPlugin
  .getExtension('page:catalog/entity')
  .override({
    factory(originalFactory) {
      const originalOutput = originalFactory();
      const originalElement = originalOutput.get(
        coreExtensionData.reactElement,
      );
      return [
        ...originalOutput,
        coreExtensionData.reactElement(
          <CustomEntityProvider>
            <EntityPageWithAnalytics>{originalElement}</EntityPageWithAnalytics>
          </CustomEntityProvider>,
        ),
      ];
    },
  });

export const catalogModuleCustomAnalytics = createFrontendModule({
  pluginId: 'catalog',
  extensions: [customCatalogPageExtension],
});
